import { useEffect } from "react";

import { useProofRebrand, useCompanyName } from "util/feature_detection";
import { NOTARIZE_DOCUMENT_TITLES, PROOF_DOCUMENT_TITLES } from "constants/document_title";
import APPS from "constants/applications";

export function useDocumentTitle(portal: string): void {
  const companyName = useCompanyName();

  useEffect(() => {
    if (!portal) {
      return;
    }

    switch (portal) {
      case APPS.ADMIN:
        window.document.title = `${companyName} | Admin`;
        break;
      case APPS.BUSINESS:
        window.document.title = `${companyName} | Business`;
        break;
      case APPS.NOTARY:
        window.document.title = `${companyName} | Notary`;
        break;
      case APPS.LENDER:
        window.document.title = `${companyName} for Lenders`;
        break;
      case APPS.TITLE_AGENCY:
        window.document.title = `${companyName} for Title Agencies`;
        break;
      case APPS.VERIFY:
        window.document.title = `${companyName} | Download a Completed Notarization`;
        break;
      case APPS.CAPTURE:
      case APPS.CUSTOMER:
      default:
        window.document.title = companyName;
        break;
    }
  }, [portal]);
}

export function useDocumentTitles() {
  return useProofRebrand() ? PROOF_DOCUMENT_TITLES : NOTARIZE_DOCUMENT_TITLES;
}
